.wrapper {
  display: flex;
  align-items: center;
  gap: 10px;

  a:any-link {
    font-weight: 500;
    text-decoration: none;
    color: var(--color-text-primary);
  }
}
